import { render, staticRenderFns } from "./show-room.vue?vue&type=template&id=07d21166"
import script from "./show-room.vue?vue&type=script&lang=js"
export * from "./show-room.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports